import {CALL_API} from 'middleware/api';
import * as ActionTypes from '../News';

function fetchNews(languageId) {
    return {
        type: ActionTypes.GET_NEWS,
        [CALL_API]: {
            endpoint: `/api/news?languageId=${languageId}`,
            method: 'get',
            types: [
                ActionTypes.SUCCESS_GET_NEWS,
                ActionTypes.FAILURE_GET_NEWS
            ]
        }
    };
}

export function getNews(languageId) {
    return (dispatch) => {
        return dispatch(fetchNews(languageId));
    };
}



// WEBPACK FOOTER //
// ./js/actions/creators/News.js